class InspirationTileController {
    constructor($state, breakpointsService, trolleyService) {
        this.$state = $state;
        this.trolleyService = trolleyService;
        this.breakpointsService = breakpointsService;
    }

    $onInit() {
        this.linkTarget = this.card.PromoOpenInNewTab ? '_blank' : undefined;
        this.linkHref = this.getLink();
    }

    getLink() {
        if (this.card.CardLinkTarget) {
            return this.card.CardLinkTarget;
        } else if (this.card.ProductGroupId) {
            return this.$state.href('shop.productgroup', { Id: this.card.ProductGroupId });
        } else if (this.card.Product) {
            return this.$state.href('shop.productdetails', { productId: this.card.Product.Stockcode, productName: this.card.Product.UrlFriendlyName, product: this.card.Product });
        } else if (this.card.RecipeId) {
            return this.$state.href('shop.recipedetail', { recipeId: this.card.RecipeId });
        }
        return this.$state.href('shop.inspirationcard', { id: this.card.ID, name: this.card.UrlPart });
    }
}

const inspirationTileComponentDefinition = {
    bindings: {
        card: '<',
        onClick: '&?',
    },
    controller: ['$state', 'BreakpointsService', 'TrolleyService', InspirationTileController],
    template: require('./inspiration-tile.component.html').trim(),
};

module.exports = {
    InspirationTileController,
    inspirationTileComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/inspiration/tile/inspiration-tile.component.js